<template>
    <div>
        <template>
            <div class="row">
                <div class="col-12 text-start mt-2">
                    <h3 class="subtitle h3 light">{{ $t('productos.productos') }}</h3>
                </div>
            </div>
            <div>
                <div class="productos-grid">
                    <div 
                        v-for="(producto, index) in productos" 
                        :key="index" 
                        class="producto-card"
                    >
                        <div class="producto-imagen">
                            <img 
                                :src="producto.item.imagen" 
                                alt="Imagen del producto" 
                                class="rounded"
                            />
                        </div>
                        <div class="producto-info">
                            <h4 class="producto-nombre">{{ producto.item.name }}</h4>
                            <ul class="producto-detalles">
                                <li>{{ producto.units }}x</li>
                            </ul>
                        </div>
                        <div class="producto-precio">
                            <p>{{ (producto.item.price * producto.units) | formatear_precio}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    export default {
        props: {
            productos: {
                type: Array,
                required: true
            }
        }
    }
</script>

<style scoped>
.productos-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 16px; 
    margin-top: 16px;
    margin-bottom: 30px;
}

.producto-card {
    background-color: #fff;
    border-radius: 8px;
    padding: 16px;
    display: flex;
    align-items: center;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); 
}

.producto-imagen img {
    height: 80px;
    width: 80px;
    object-fit: cover;
    border-radius: 8px;
    margin-right: 16px; 
}

.producto-info {
    flex-grow: 1;
}

.producto-nombre {
    font-weight: bold;
    font-size: 1.1rem;
    margin-bottom: 4px;
}

.producto-detalles {
    list-style: none;
    margin: 0;
    padding: 0;
    font-size: 0.9rem;
}

.producto-precio p {
    margin: 0;
    font-weight: bold;
    font-size: 1rem;
    color: #333;
}
</style>